module.exports = {"platforms":[{"message":"barrier","type":"FiniteImmobilePlatform","x":1,"y":9,"width":23,"height":1,"display":{"assetName":"spikes"},"attributes":{"spiked":true}},{"message":"start platform","type":"FiniteImmobilePlatform","x":11,"y":3,"width":5,"height":1,"display":{"assetName":"lanterns"}},{"message":"the enemy's gate is down","type":"FiniteImmobilePlatform","x":9,"y":13,"width":9,"height":1,"display":{"assetName":"lanterns"}}],"goal":{"x":13,"y":13},"player":{"x":13,"y":2},"par":2,"scale":32}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/friend-6-drop.json
// module id = 142
// module chunks = 0